function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  padding-top: 56.25%; /* 16:9 Aspect Ratio */\n  background-color: #000;\n  border-radius: 8px;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 10;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top: 3px solid #fff;\n  animation: spin 1s linear infinite;\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 20px;\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useEffect, useRef, useState, useCallback } from 'react';
import styled from '@emotion/styled';
import Hls from 'hls.js';
import { tokenManager } from '@edusense/shared-auth-core';
var PlayerWrapper = styled.div(_templateObject());
var StyledVideo = styled.video(_templateObject1());
var LoadingOverlay = styled.div(_templateObject2());
var Spinner = styled.div(_templateObject3());
var ErrorMessage = styled.div(_templateObject4());
/**
 * useHlsPlayer hook - reference 구현을 기반으로 한 HLS 관리
 */ var useHlsPlayer = function(param) {
    var videoElement = param.videoElement, src = param.src, _param_autoPlay = param.autoPlay, autoPlay = _param_autoPlay === void 0 ? false : _param_autoPlay, onError = param.onError, onLoadedData = param.onLoadedData, _param_maxRetries = param.maxRetries, maxRetries = _param_maxRetries === void 0 ? 3 : _param_maxRetries;
    console.log('🎬 [useHlsPlayer] Hook called with:', {
        hasVideoElement: !!videoElement,
        src: src,
        autoPlay: autoPlay,
        maxRetries: maxRetries,
        isHLS: (src === null || src === void 0 ? void 0 : src.includes('.m3u8')) || (src === null || src === void 0 ? void 0 : src.includes('/hls/'))
    });
    var hlsInstanceRef = useRef(null);
    var retryCountRef = useRef(0);
    var onErrorRef = useRef(onError);
    var onLoadedDataRef = useRef(onLoadedData);
    var configRef = useRef({
        debug: process.env.NODE_ENV === 'development',
        enableWorker: true,
        lowLatencyMode: false,
        backBufferLength: 90,
        maxBufferLength: 120,
        maxMaxBufferLength: 600,
        maxBufferSize: 60 * 1000 * 1000,
        manifestLoadingTimeOut: 20000,
        manifestLoadingMaxRetry: 4,
        manifestLoadingRetryDelay: 1000,
        levelLoadingTimeOut: 20000,
        levelLoadingMaxRetry: 4,
        levelLoadingRetryDelay: 1000,
        fragLoadingTimeOut: 30000,
        fragLoadingMaxRetry: 5,
        fragLoadingRetryDelay: 1000,
        maxBufferHole: 2.0,
        maxSeekHole: 2.5,
        xhrSetup: function(xhr) {
            console.log('[useHlsPlayer] xhrSetup executing...');
            xhr.withCredentials = true;
            xhr.timeout = 30000;
            xhr.setRequestHeader('Accept', 'application/vnd.apple.mpegurl, */*');
            // Authorization 헤더 추가
            var accessToken = tokenManager.getToken();
            if (accessToken) {
                xhr.setRequestHeader('Authorization', "Bearer ".concat(accessToken));
                console.log('[useHlsPlayer] Added Authorization header to HLS request');
            }
        }
    });
    var _useState = _sliced_to_array(useState(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = _sliced_to_array(useState(function() {
        var supported = Hls.isSupported();
        console.log("[useHlsPlayer] Initial HLS support check: ".concat(supported));
        return supported;
    }), 1), isHlsSupported = _useState2[0];
    // Update refs when props change
    useEffect(function() {
        onErrorRef.current = onError;
        onLoadedDataRef.current = onLoadedData;
    }, [
        onError,
        onLoadedData
    ]);
    // HLS URL 확인
    var isHlsUrl = useCallback(function(url) {
        if (!url) return false;
        var lowerUrl = url.toLowerCase();
        return lowerUrl.endsWith('.m3u8') || lowerUrl.includes('/hls/');
    }, []);
    // Core Effect for HLS Management
    useEffect(function() {
        console.log("[useHlsPlayer] Core Effect Triggered. Props: src='".concat(src, "', videoElement? ").concat(!!videoElement));
        if (!videoElement || !src) {
            console.warn('[useHlsPlayer] Core Effect: Bailing out - videoElement or src is missing.');
            if (hlsInstanceRef.current) {
                console.log('[useHlsPlayer] Cleaning up existing HLS instance (bail out).');
                hlsInstanceRef.current.destroy();
                hlsInstanceRef.current = null;
            }
            setLoading(false);
            setError(null);
            return;
        }
        var shouldManageHls = isHlsUrl(src);
        console.log("[useHlsPlayer] Core Effect: isHlsUrl=".concat(shouldManageHls, ", isHlsSupported=").concat(isHlsSupported));
        if (shouldManageHls) {
            if (isHlsSupported) {
                console.log('[useHlsPlayer] Attempting HLS setup...');
                setLoading(true);
                setError(null);
                retryCountRef.current = 0;
                // Destroy previous instance BEFORE creating a new one
                if (hlsInstanceRef.current) {
                    console.log('[useHlsPlayer] Destroying previous HLS instance before creating new one.');
                    hlsInstanceRef.current.destroy();
                    hlsInstanceRef.current = null;
                }
                try {
                    if (!videoElement) {
                        console.warn('[useHlsPlayer] videoElement became null before HLS instance creation.');
                        setLoading(false);
                        return;
                    }
                    console.log('[useHlsPlayer] Creating new Hls instance with config:', configRef.current);
                    var hls = new Hls(configRef.current);
                    hlsInstanceRef.current = hls;
                    var internalOnError = function(_event, data) {
                        var _data_details, _data_details1, _data_response_text, _data_response, _data_response_text1, _data_response1, _onErrorRef_current;
                        console.error('[useHlsPlayer] HLS.Events.ERROR received:', data);
                        var HlsErrorTypes = Hls === null || Hls === void 0 ? void 0 : Hls.ErrorTypes;
                        var errorMessage = "HLS 오류: ".concat(data.details || '알 수 없는 오류');
                        var isFatal = data.fatal;
                        if (((_data_details = data.details) === null || _data_details === void 0 ? void 0 : _data_details.includes('cors')) || ((_data_details1 = data.details) === null || _data_details1 === void 0 ? void 0 : _data_details1.includes('access')) || ((_data_response = data.response) === null || _data_response === void 0 ? void 0 : (_data_response_text = _data_response.text) === null || _data_response_text === void 0 ? void 0 : _data_response_text.includes('CORS')) || ((_data_response1 = data.response) === null || _data_response1 === void 0 ? void 0 : (_data_response_text1 = _data_response1.text) === null || _data_response_text1 === void 0 ? void 0 : _data_response_text1.includes('cross-origin'))) {
                            errorMessage = "CORS 오류: 스트리밍 서버(".concat(data.url || src, ")에 접근할 수 없습니다.");
                            isFatal = true;
                        }
                        if (isFatal && HlsErrorTypes) {
                            switch(data.type){
                                case HlsErrorTypes.NETWORK_ERROR:
                                    if (retryCountRef.current < maxRetries) {
                                        var _hlsInstanceRef_current;
                                        retryCountRef.current++;
                                        console.warn("HLS 네트워크 오류, 재시도 ".concat(retryCountRef.current, "/").concat(maxRetries));
                                        (_hlsInstanceRef_current = hlsInstanceRef.current) === null || _hlsInstanceRef_current === void 0 ? void 0 : _hlsInstanceRef_current.startLoad();
                                        return;
                                    } else {
                                        errorMessage = "네트워크 오류: 비디오를 로드할 수 없습니다(".concat(retryCountRef.current, "번 재시도 실패).");
                                    }
                                    break;
                                case HlsErrorTypes.MEDIA_ERROR:
                                    if (retryCountRef.current < maxRetries && data.details !== 'bufferStalledError') {
                                        var _hlsInstanceRef_current1;
                                        retryCountRef.current++;
                                        console.warn("HLS 미디어 오류(".concat(data.details, "), 재시도 ").concat(retryCountRef.current, "/").concat(maxRetries));
                                        (_hlsInstanceRef_current1 = hlsInstanceRef.current) === null || _hlsInstanceRef_current1 === void 0 ? void 0 : _hlsInstanceRef_current1.recoverMediaError();
                                        return;
                                    } else {
                                        errorMessage = "미디어 오류(".concat(data.details, "): 비디오를 재생할 수 없습니다.");
                                    }
                                    break;
                            }
                        }
                        setError(errorMessage);
                        setLoading(false);
                        (_onErrorRef_current = onErrorRef.current) === null || _onErrorRef_current === void 0 ? void 0 : _onErrorRef_current.call(onErrorRef, errorMessage);
                    };
                    var internalOnManifestParsed = function() {
                        var _onLoadedDataRef_current;
                        console.log('[useHlsPlayer] HLS.Events.MANIFEST_PARSED received.');
                        setLoading(false);
                        setError(null);
                        (_onLoadedDataRef_current = onLoadedDataRef.current) === null || _onLoadedDataRef_current === void 0 ? void 0 : _onLoadedDataRef_current.call(onLoadedDataRef);
                    };
                    console.log('[useHlsPlayer] Attaching HLS event listeners...');
                    hls.on(Hls.Events.ERROR, internalOnError);
                    hls.on(Hls.Events.MANIFEST_PARSED, internalOnManifestParsed);
                    console.log("[useHlsPlayer] Loading source: ".concat(src));
                    hls.loadSource(src);
                    console.log('[useHlsPlayer] Attaching media to video element...');
                    hls.attachMedia(videoElement);
                    console.log('[useHlsPlayer] HLS setup complete.');
                } catch (initError) {
                    var _onErrorRef_current;
                    console.error('[useHlsPlayer] HLS initialization failed:', initError);
                    var initErrorMessage = "HLS 초기화 실패: ".concat(initError.message);
                    setError(initErrorMessage);
                    setLoading(false);
                    (_onErrorRef_current = onErrorRef.current) === null || _onErrorRef_current === void 0 ? void 0 : _onErrorRef_current.call(onErrorRef, initErrorMessage);
                    if (hlsInstanceRef.current) {
                        hlsInstanceRef.current.destroy();
                        hlsInstanceRef.current = null;
                    }
                }
            } else {
                var _onErrorRef_current1;
                console.warn('[useHlsPlayer] HLS URL detected, but HLS is not supported.');
                var noSupportMsg = '이 브라우저는 HLS 스트리밍을 지원하지 않습니다.';
                setError(noSupportMsg);
                setLoading(false);
                (_onErrorRef_current1 = onErrorRef.current) === null || _onErrorRef_current1 === void 0 ? void 0 : _onErrorRef_current1.call(onErrorRef, noSupportMsg);
                if (hlsInstanceRef.current) {
                    hlsInstanceRef.current.destroy();
                    hlsInstanceRef.current = null;
                }
            }
        } else {
            console.log('[useHlsPlayer] Not an HLS URL. Cleaning up any existing HLS instance.');
            if (hlsInstanceRef.current) {
                hlsInstanceRef.current.destroy();
                hlsInstanceRef.current = null;
            }
            setLoading(false);
            setError(null);
        }
        return function() {
            console.log('[useHlsPlayer] Cleanup function running.');
            if (hlsInstanceRef.current) {
                console.log('[useHlsPlayer] Destroying HLS instance in cleanup.');
                hlsInstanceRef.current.destroy();
                hlsInstanceRef.current = null;
            }
        };
    }, [
        videoElement,
        src,
        isHlsSupported,
        isHlsUrl,
        maxRetries
    ]);
    return {
        loading: loading,
        error: error
    };
};
/**
 * HLS 스트리밍을 지원하는 비디오 플레이어 컴포넌트
 */ var VideoPlayer = function(param) {
    var src = param.src, poster = param.poster, _param_autoPlay = param.autoPlay, autoPlay = _param_autoPlay === void 0 ? false : _param_autoPlay, _param_controls = param.controls, controls = _param_controls === void 0 ? true : _param_controls, _param_muted = param.muted, muted = _param_muted === void 0 ? false : _param_muted, _param_loop = param.loop, loop = _param_loop === void 0 ? false : _param_loop, className = param.className, onPlay = param.onPlay, onPause = param.onPause, onEnded = param.onEnded, onError = param.onError, onLoadedData = param.onLoadedData;
    console.log('🎥 [VideoPlayer] Component rendered with props:', {
        src: src,
        poster: poster,
        autoPlay: autoPlay,
        controls: controls,
        muted: muted,
        loop: loop,
        isHLS: (src === null || src === void 0 ? void 0 : src.includes('.m3u8')) || (src === null || src === void 0 ? void 0 : src.includes('/hls/')),
        srcLength: src === null || src === void 0 ? void 0 : src.length
    });
    var videoRef = useRef(null);
    // HLS hook 사용
    var _useHlsPlayer = useHlsPlayer({
        videoElement: videoRef.current,
        src: src,
        autoPlay: autoPlay,
        onError: function(errorMsg) {
            return onError === null || onError === void 0 ? void 0 : onError(new Error(errorMsg));
        },
        onLoadedData: onLoadedData
    }), loading = _useHlsPlayer.loading, error = _useHlsPlayer.error;
    // HLS URL 확인
    var isHlsUrl = useCallback(function(url) {
        if (!url) return false;
        var lowerUrl = url.toLowerCase();
        return lowerUrl.endsWith('.m3u8') || lowerUrl.includes('/hls/');
    }, []);
    // 일반 비디오 처리
    useEffect(function() {
        if (!src || !videoRef.current || isHlsUrl(src)) {
            return;
        }
        console.log('[VideoPlayer] Setting up regular video:', src);
        videoRef.current.src = src;
    }, [
        src,
        isHlsUrl
    ]);
    return /*#__PURE__*/ React.createElement(PlayerWrapper, {
        className: className
    }, loading && /*#__PURE__*/ React.createElement(LoadingOverlay, null, /*#__PURE__*/ React.createElement(Spinner, null)), error && /*#__PURE__*/ React.createElement(ErrorMessage, null, error), /*#__PURE__*/ React.createElement(StyledVideo, {
        ref: videoRef,
        poster: poster,
        controls: controls,
        muted: muted,
        loop: loop,
        autoPlay: autoPlay && !isHlsUrl(src),
        playsInline: true,
        onPlay: onPlay,
        onPause: onPause,
        onEnded: onEnded,
        onLoadedData: onLoadedData
    }, "브라우저가 비디오 태그를 지원하지 않습니다."));
};
export default VideoPlayer;
